<template lang='pug'>
layout-page
    div(style="padding: 10px;")
        //- keep-alive
        //-   router-view(v-if="$route.meta.keepAlive && isRouterAlive")
        router-view
        div#vue(v-if="this.$route.path.length!=1 || teral") 


</template>

<script type="text/javascript">
import layoutPage from '@/layout/layout-page.vue'
export default {
  name: 'App',

  components: {
      layoutPage
  },
  
  provide () {
    return {
      reload: this.reload
    }
  },
  created(){
    this.$router.beforeEach((to, from, next) => {
        // console.log(to);
        // console.log(from);
        if(to.path == '/files/launch_contract/setmeal_list'){
          return next('/launch_contract/setmeal_list')
        }
        if(to.path == '/acctuserfile/launch_contract/setmeal'){
          this.show=true
          return next('/launch_contract/setmeal_list')
        }
        if(to.path == '/files/tore/serve'){
          return next('/tore/serve')
        }
        if(to.path == '/files/noun/particulars'){
          return next('/noun/particulars')
        }
        if(to.path == '/files/acctuser'){
          return next('/acctuser')
        }if(to.path == '/files/acctuser/firm/approve'){
          return next('/acctuser/firm/approve')
        }
        if(to.path == '/noun/files/acctuserfile'){
          return next('/files/acctuserfile')
        }
       


         if(to.path == '/tore/files/signature'){
           let ac=localStorage.getItem('look')
           let ar=localStorage.getItem('num')
           let  vc='/files/signature?contract_id='+ac+'&type='+1
           console.log(vc.replace(/\s*/g,""))
          this.$router.push({path:vc.replace(/\s*/g,""),})
        };
        if(to.path == '/tore/noun/particulars'){
           let ac=localStorage.getItem('evidence')
           let  vc='/noun/particulars?id='+ac
          //  console.log(vc.replace(/\s*/g,""))
          this.$router.push({path:vc.replace(/\s*/g,""),})
        };
        // if(to.path == '/files/launch_contract/setmeal_list'){
        //   return next('/launch_contract/setmeal_list')
        // };
        if(to.path == '/tore/noun/evidence'){
          return next('/noun/evidence')
        };
        //  if(to.path == '/files/launch_contract/setmeal_list'){
        //   return next('/launch_contract/setmeal_list')
        // }
   

        next();
    });

  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },

  data () {
    return {
        isRouterAlive: true,
        teral:true
    }
  }
}
</script>
